import React from 'react'
import '../../css/sections/Quote.css';

function Quote({ darkLogo }) {
  return (
    <div className='quote-container'>
      <div className='quote-heading'>
          <h1 className='quote'><span className='special-font' style={{ fontStyle: "italic" }}>Difficult</span> Takes A <span className='special-font' style={{ fontStyle: "italic" }}>Day</span>, <span className='special-font' style={{ fontStyle: "italic" }}>Impossible</span> Takes A <span className='special-font' style={{ fontStyle: "italic" }}>Week</span>.</h1>
      </div>
    </div>
  )
}

export default Quote
